import { Suspense, type ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { RoleRoute } from '../components/common/ProtectedRoute.js';
import { EXTENSION_ROUTES } from './coreRoutes.js';
import { resolvePageComponent } from './pageRegistry.js';

/** The build-time slot's direct routes for App's shell; a `requiredRole` renders behind RoleRoute, like /console. */
export function buildExtensionRoutes(fallback: ReactNode): ReactNode[] {
  return EXTENSION_ROUTES.flatMap(({ path, component, requiredRole }) => {
    const Page = resolvePageComponent(component);
    if (!Page) return [];
    const route = <Route key={path} path={path} element={<Suspense fallback={fallback}><Page /></Suspense>} />;
    return [requiredRole ? <Route key={path} element={<RoleRoute requiredRole={requiredRole} />}>{route}</Route> : route];
  });
}
